import React, { Component } from "react";
import { ExpansionPanel, ExpansionPanelSummary, ExpansionPanelDetails } from '@material-ui/core/';
import { ExpandMore, ExpandLess } from '@material-ui/icons';
import _, { stubFalse } from "lodash";
import { Card, CardBody, CardHeader, Label, Row, Col, Button } from "reactstrap";
import Loader from "./../../../../../Global/Loader";
import Fade from "react-reveal/Fade";
import { formatMeasurement } from "../../../../../utils/formatMeasurement";

import Tooltip from "@mui/material/Tooltip";
import Table from "../../../../Components/Table";
import axios from "axios";
import { Services } from "../../../Services";
import { TextArea } from "semantic-ui-react";
import { Autocomplete, TextField } from "@mui/material";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import esLocale from 'date-fns/locale/es';
import enLocale from 'date-fns/locale/en-US';
import { withStyles } from "@material-ui/core/styles";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers';
import StepperEvent from '../../../../Components/StepperEvent';
import moment from "moment";
import { withRouter, Link } from "react-router-dom";
import { openNotification } from "../../../../Components/Notification";
import Template from "../../../template";
import ContainerWrapper from "../../../../../template/Layout/ContentWrapper";
import Proveedor from "./../../../components/Proveedor";
import Consignatario from "./../../../components/Consignatario"

import "./../../styles/styles.scss";
import { withNamespaces } from 'react-i18next';
import { __RouterContext } from "react-router";




const useStyles = (theme) => ({
  textfield: {
    "& .MuiInputBase-input.MuiAutocomplete-input": {
      fontSize: 12,
      color: "#000a2e"
    }
  },
  datefield: {
    "& .MuiInput-input.MuiInputBase-input": {
      fontSize: 12,
      color: "#000a2e"
    }
  },
  searchLabel: {
    fontSize: 12,
    color: "#000a2e"
  },
  euroDateField: {
    "& .MuiCalendarPicker-root": {
      fontSize: 12,
      color: "#000a2e"
    }
  },
  popupIndicator: {
    "& path": {
      d: "path('M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z')",
    },
  },
  popupIndicatorOpen: {
    "& path": {
      d: "path('M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z')",
    },
  },
});

class createUsers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMobil: false,
      tableEntityConf: [
        { label: "ID", key: "EntityId" },
        { label: this.props.t("organization_name"), key: "Name" },
        { label: this.props.t("organization_code"), key: "Code" },
        { label: this.props.t("phone"), key: "Telephone" },
        { label: this.props.t("country"), key: "Country" },
      ],
      data: {},
      steps: this.props.steps,
      TemplateForms: _.cloneDeep(Template),
      fieldByStatus: [{
        "status": [6],
        "fields": ["EstPickupDate", "ActualPickupDate", "FinalDestinationArrivalDate", "TransitToFinalDestinationDate"]
      }, {
        "status": [8, 9, 10, 11, 12],
        "fields": ["TransitToFinalDestinationDate", "FinalDestinationArrivalDate"]
      }],
      fieldsDependency: [
        ["GrossWeight", "UOMWeight"],
        ["Length", "Height", "Width", "UOMDimensions"]
      ],
      TemplateEmbarque: {
        titulo: this.props.t("shipment_info"),
        logo: "ubicacion",
        embarque: [{
          type: 'LabelLink',
          label: this.props.t("shipment_no"),
          name: 'ShipmentNumber',
          class: 'col-md-2 input-form',
          id: 'ShipmentNumber',
          val: "ShipmentNumber"
        }, {
          type: 'Label',
          label: this.props.t("shipment_type"),
          name: 'ShipmentType',
          class: 'col-md-2 input-form',
          id: 'ShipmentType'
        }, {
          type: 'Label',
          label: this.props.t("origin"),
          name: 'POL',
          class: 'col-md-2 input-form',
          id: 'POL'
        }, {
          type: 'Label',
          label: this.props.t("destination"),
          name: 'POD',
          class: 'col-md-2 input-form',
          id: 'POD'
        }, {
          type: 'Label',
          label: this.props.t("etd"),
          name: 'ETD',
          class: 'col-md-2 input-form',
          id: 'ETD'
        }, {
          type: 'Label',
          label: this.props.t("eta"),
          name: 'ETA',
          class: 'col-md-2 input-form',
          id: 'ETA'
        }, {
          type: 'Label',
          label: 'HBL/HAWB',
          name: 'HBL_HAWB',
          class: 'col-md-2 input-form',
          id: 'HBL_HAWB'
        }, {
          type: 'Label',
          label: 'MBL/AWB/PRO No.',
          name: 'MBL_AWB_PRO',
          class: 'col-md-2 input-form',
          id: 'MBL_AWB_PRO'
        }, {
          type: 'Label',
          label: this.props.t("carrier"),
          name: 'Carrier',
          class: 'col-md-2 input-form',
          id: 'Carrier'
        }, {
          type: 'Label',
          label: this.props.t("vessel"),
          name: 'Vessel',
          class: 'col-md-2 input-form',
          id: 'Vessel'
        }, {
          type: 'Label',
          label: this.props.t("trip_flight_Truck_num"),
          name: 'Voyage_FlightNumber',
          class: 'col-md-4 input-form',
          id: 'Voyage_FlightNumber'
        }]
      },
      createFormsData: [],
      createForms: [],
      generalInfo: [],
      info: this.props.info ? this.props.info : {},
      unEditedInfo: {},
      selectCatalog: [],
      camposUsuario: true,
      guardarDisabled: true,
      confirmPassError: false,
      isEditing: false,
      tablaClientes: "",
      pickupAddressInput: true,
      deliverAddressInput: true,
      idOrdenServicio: this.props.idinfo ? this.props.idinfo : 0,
      infoEmbarque: this.props.infoEmbarque ? this.props.infoEmbarque : {},
      embarqueInfo: [],
      dateOpen: [],
      loadingInfo: true,
      loadingTmpInfo: false,
      panelEmbarque: true,
      containerColumns: [
        { label: this.props.t("contianer_num"), key: "ContainerNo", minWidth: 310, maxWidth: 310 },
        { label: this.props.t("seal"), key: "Seal", minWidth: 310, maxWidth: 310 },
        { label: this.props.t("container_type"), key: "ContainerType", minWidth: 310, maxWidth: 310 }

      ]
    };
  }

  componentDidMount = async () => {
    let { info, selectCatalog } = this.state;

    let details = navigator.userAgent;
    let regexp = /android|iphone|kindle|ipad/i;
    let isMobileDevice = regexp.test(details);

    this.setState({
      isMobil: isMobileDevice
    })


    let campo = info.TransportModeId;
    // this.getRoles();
    // this.getUser();
    await this.getCatalogs();
    this.changeFieldsByStatus();
    if (this.state.isEditing) {
      this.renderForm(true);
    } else {
      this.setState({ loadingInfo: true }, () => {
        axios
          .get(`${Services.ORDEN_SERV.path}orden/freightterms/${campo}`, {})
          .then((response) => {
            selectCatalog["FreightTerms"] = this.sortCatalogs(response.data.tramoContratado, "text");
            this.setState(
              {
                selectCatalog,
                loadingInfo: false,
                pickupAddressInput: false,
                deliverAddressInput: false,
                info
              },
              () => {
                this.generarInfoGeneral();
                this.generarInfoEmbarque();
              }
            );
          })
          .catch((error) => {
            console.warn(error);
          });
      })

    }

  };
  componentWillReceiveProps = (nextProps) => {

    this.setState(
      {
        steps: nextProps.steps,
        Form: nextProps.form,
        isEditing: nextProps.isEditing,
        isEdit: nextProps.isEditing,
        info: nextProps.info,
        infoEmbarque: nextProps.infoEmbarque
      }, () => {
        if (this.state.isEditing) {
          this.state.TemplateForms.map((TemplateForm) => {
            TemplateForm["edit"].map((field) => {
              this.state.fieldsDependency.forEach((fieldArray) => {
                if (fieldArray.indexOf(field.id) >= 0) {
                  let flagRequired = false;
                  fieldArray.forEach((field) => {
                    if (!flagRequired) {
                      flagRequired = this.state.info[field] && this.state.info[field] != "";
                    }
                  })
                  if (fieldArray.indexOf(field.id) >= 0) {
                    field.required = flagRequired;
                  }
                }
              })
            })
          })
          this.verificarDireccion(this.state.info, true);
          this.verificarAccount();
        } else {

          this.generarInfoGeneral();
          this.generarInfoEmbarque();
        }
      }
    );
  };


  changeFieldsByStatus = () => {
    let { info, fieldByStatus } = this.state;
    let aviableFields = "";
    fieldByStatus.map((fields) => {
      if (fields.status.indexOf(info.StatusId) >= 0) {
        aviableFields = fields.fields;
      }
    })
    if (aviableFields != "") {

      this.state.TemplateForms.map((TemplateForm) => {
        TemplateForm["edit"].map((field) => {
          if (aviableFields.indexOf(field.id) < 0) {
            if (field.type == "CustomEntidades") {
              field.edit = 0;
            } else {
              field.type = "Label";
            }

          }
        })
      });
    }
  }

  verificarAccount = () => {
    let { info, selectCatalog } = this.state;
    let epCode = "";
    selectCatalog["Entities"].map((ent) => {
      if (ent.value == info.CustomerId) {
        epCode = ent.data.CodeEP;
      }
    })
    this.setState({ loadingTmpInfo: true }, () => {
      axios
        .get(`${Services.ORDEN_SERV.path}orden/accountsByCustomer/${epCode}`, {})
        .then((response) => {
          selectCatalog["consignees"] = this.sortCatalogs(response.data.data.Consignees, "entityName");
          selectCatalog["suppliers"] = this.sortCatalogs(response.data.data.Suppliers, "entityName");
          this.setState(
            {
              selectCatalog,
              loadingTmpInfo: false,
              info
            },
            () => {
              this.renderForm(true);
            }
          );
        })
        .catch((error) => {
          console.warn(error);
        });
    })
  }

  handleChangeDrop = (attribute, isEdit) => (evt, data) => {
    let { info, showClientes, guardarDisabled, pickupAddressInput, deliverAddressInput, selectCatalog, fieldsDependency } = this.state;
    let campo = data ? data.value : null;

    info[attribute] = campo;
    if (campo !== null) {
      if (attribute == "FreightTermCode") {
        let [recoleccionCode, entregaCode] = data.value.split("2");
        let labelRecoleccion = recoleccionCode == "D";
        let labelEntrega = entregaCode == "D";
        this.state.TemplateForms[2][isEdit ? "edit" : "create"].map((campo) => {

          if (["SpecialInstructions", "PickupGoods"].indexOf(campo.id) >= 0) {
            campo.type = (campo.id == "PickupGoods" && labelRecoleccion) ||
              (campo.id == "SpecialInstructions" && labelEntrega) ? "LabelRef" : "Input";
          }


        })
        info["PickupGoods"] = labelRecoleccion ? info["PickupAddress"] : "";
        info["SpecialInstructions"] = labelEntrega ? info["DeliveryAddress"] : "";
        pickupAddressInput = !labelRecoleccion;
        deliverAddressInput = !labelEntrega;
      } else if (attribute == "TransportModeId") {

        if (campo != "") {
          info["FreightTermCode"] = "";
          this.setState({ loadingTmpInfo: true }, () => {
            axios
              .get(`${Services.ORDEN_SERV.path}orden/freightterms/${campo}`, {})
              .then((response) => {
                selectCatalog["FreightTerms"] = response.data.tramoContratado;
                this.setState(
                  {
                    selectCatalog,
                    loadingInfo: false,
                    loadingTmpInfo: false,
                    pickupAddressInput: false,
                    deliverAddressInput: false,
                    info
                  },
                  () => {
                    this.verificarDireccion(this.state.info, true);
                    this.renderForm(isEdit);
                  }
                );
              })
              .catch((error) => {
                console.warn(error);
              });
          })
        } else {
          selectCatalog["FreightTerms"] = [];
        }
      } else if (attribute == "CustomerId") {
        info["ConsigneeId"] = "";
        info["SupplierId"] = "";
        info["DeliveryAddress"] = "";
        info["PickupAddress"] = "";

        info["ConsigneeContacId"] = "";
        info["SupplierContactId"] = "";
        info["CheckDeliveryAddress"] = false;
        info["CheckPickupAddress"] = false;

        let limpiarRecoleccion = true;
        let limpiarEntrega = true;
        if (info["FreightTermCode"]) {
          let [recoleccionCode, entregaCode] = info["FreightTermCode"].split("2");
          limpiarRecoleccion = recoleccionCode == "D";
          limpiarEntrega = entregaCode == "D";
        }
        info["SpecialInstructions"] = limpiarRecoleccion ? "" : info["SpecialInstructions"];
        info["PickupGoods"] = limpiarEntrega ? "" : info["PickupGoods"];

        if (campo != "") {
          let epCode = "";
          selectCatalog["Entities"].map((ent) => {
            if (ent.value == campo) {
              epCode = ent.data.CodeEP;
            }
          })
          this.setState({ loadingTmpInfo: true }, () => {
            axios
              .get(`${Services.ORDEN_SERV.path}orden/accountsByCustomer/${epCode}`, {})
              .then((response) => {
                selectCatalog["consignees"] = response.data.data.Consignees;
                selectCatalog["suppliers"] = response.data.data.Suppliers;
                this.setState(
                  {
                    selectCatalog,
                    loadingTmpInfo: false,
                    info
                  },
                  () => {
                    this.renderForm(isEdit);
                  }
                );
              })
              .catch((error) => {
                console.warn(error);
              });
          })
        }

      }
    } else {
      if (attribute == "TransportModeId") {
        info["FreightTermCode"] = null;
        selectCatalog["FreightTerms"] = [];
        this.state.TemplateForms[2][isEdit ? "edit" : "create"].map((campo) => {

          if (["SpecialInstructions", "PickupGoods"].indexOf(campo.id) >= 0) {
            campo.type = "Input";
          }


        })
      } else if (attribute == "CustomerId") {
        selectCatalog["consignees"] = [];
        selectCatalog["suppliers"] = [];
        let limpiarRecoleccion = true;
        let limpiarEntrega = true;
        if (info["FreightTermCode"]) {
          let [recoleccionCode, entregaCode] = info["FreightTermCode"].split("2");
          limpiarRecoleccion = recoleccionCode == "D";
          limpiarEntrega = entregaCode == "D";
        }
        info["SpecialInstructions"] = limpiarEntrega ? "" : info["SpecialInstructions"];
        info["PickupGoods"] = limpiarRecoleccion ? "" : info["PickupGoods"];
      }
    }

    fieldsDependency.forEach((fieldArray) => {
      if (fieldArray.indexOf(attribute) >= 0) {
        let flagRequired = false;
        fieldArray.forEach((field) => {
          if (!flagRequired) {
            flagRequired = info[field] && info[field] != "";
          }
        })


        this.state.TemplateForms.map((TemplateForm) => {
          TemplateForm[isEdit ? "edit" : "create"].map((field) => {
            if (fieldArray.indexOf(field.id) >= 0) {
              field.required = flagRequired;
            }
          })
        })
      }
    })

    this.setState({ info, showClientes, guardarDisabled, deliverAddressInput, pickupAddressInput, selectCatalog }, () => {
      this.renderForm(isEdit);
      // this.validateSaveOrder()
    }
    );
  };

  onlyUnique = (value, index, self) => {
    return self.indexOf(value) === index && value != null && value != "";
  };

  handleChangeFilter =
    (campo, isEdit) => (nextTargetKeys, direction, moveKeys) => {
      let { info, guardarDisabled } = this.state;
      if (info[campo]) {
        if (direction === "left") {
          moveKeys.forEach((key) => {
            var removeKey = info[campo].indexOf(key);
            if (removeKey > -1) {
              info[campo].splice(removeKey, 1);
            }
          });
          this.sendMessage(this.props.t("retired"), "info");
        } else {
          moveKeys.forEach((key) => {
            info[campo].push(key);
          });
          this.sendMessage(this.props.t("added"), "info");
        }

        info[campo] = info[campo].filter(this.onlyUnique);
      } else {
        this.sendMessage(this.props.t("added"), "info");
        info[campo] = moveKeys;
      }
      guardarDisabled = true;
      if (
        [1, 2].indexOf(info["RoleId"]) >= 0 ||
        (info[campo] && info[campo].length > 0)
      ) {
        guardarDisabled = false;
      }

      this.setState({ info, guardarDisabled });
    };

  // sendMessage = (text, type) => {
  //   Swal.fire({
  //     icon: type,
  //     confirmButtonColor: "#000a2e",
  //     confirmButtonText: "Ok",
  //     html: `<div class="text-center">
  //       ${text}
  //       </div>`,
  //   });
  // }

  sendMessage = (text, type) => {
    openNotification(type, text);
  };





  verificarDireccion = (info, udpateState) => {
    let { isEditing, fieldByStatus } = this.state;
    let aviableFields = [];
    fieldByStatus.map((fields) => {
      if (fields.status.indexOf(info.StatusId) >= 0) {
        aviableFields = fields.fields;
      }
    })
    if ((aviableFields.indexOf("SpecialInstructions") >= 0 &&
      aviableFields.indexOf("PickupGoods") >= 0) || aviableFields.length == 0) {
      let [recoleccionCode, entregaCode] = info["FreightTermCode"].split("2");
      let labelRecoleccion = recoleccionCode == "D";
      let labelEntrega = entregaCode == "D";
      this.state.TemplateForms[2][isEditing ? "edit" : "create"].map((campo) => {

        if (["SpecialInstructions", "PickupGoods"].indexOf(campo.id) >= 0) {
          campo.type = (campo.id == "PickupGoods" && labelRecoleccion) ||
            (campo.id == "SpecialInstructions" && labelEntrega) ? "LabelRef" : "Input";
          console.log("especial instructions");
        }


      })
      info["PickupGoods"] = labelRecoleccion ? info["PickupAddress"] : info["PickupGoods"];
      info["SpecialInstructions"] = labelEntrega ? info["DeliveryAddress"] : info["SpecialInstructions"];
      let pickupAddressInput = !labelRecoleccion;
      let deliverAddressInput = !labelEntrega;
      if (udpateState) {
        this.setState({
          pickupAddressInput,
          deliverAddressInput
        })
      }
    }



  }

  obtenerTablaClientes = (EntitiesIds) => {
    var arrayEntity = [];

    EntitiesIds.map((entId) => {
      this.state.selectCatalog["Entities"].map((catEnt) => {
        if (entId === catEnt.key) {
          arrayEntity.push(catEnt.data);
        }
      });
    });

    return (
      <Table
        columns={this.state.tableEntityConf}
        data={arrayEntity}
        itemsByPage={5}
        options={{
          large: true,
          downloads: {
            pdf: false,
            xlsx: false,
          },
          pagination: true,
          search: true,
        }}
      />
    );
  };

  obtenerNombreReportes = (ReportsIds) => {
    let ReportsName = [];
    if (ReportsIds && ReportsIds.length > 0) {
      ReportsIds.map((id) => {
        this.state.selectCatalog["Reportes"].map((reporte) => {
          if (id === reporte.key) {
            ReportsName.push(reporte.text);
          }
        });
      });
    }
    return ReportsName;
  };

  getCatalogs = async () => {
    let { selectCatalog } = this.state;

    let userId = this.props.userid;
    await axios
      .get(`${Services.ORDEN_SERV.path}orden/catalogs/${userId}?lang=${this.props.lng}`, {})
      .then((response) => {
        selectCatalog["Incoterm"] = this.sortCatalogs(response.data.incoterms, "text");
        selectCatalog["UOMVolume"] = this.sortCatalogs(response.data.volume, "text");
        selectCatalog["UOMWeight"] = this.sortCatalogs(response.data.weight, "text");
        selectCatalog["UOMDimension"] = this.sortCatalogs(response.data.dimension, "text");
        selectCatalog["UOMQty"] = this.sortCatalogs(response.data.qty, "text");
        selectCatalog["Entities"] = this.sortCatalogs(response.data.clientes, "text");
        selectCatalog["TransportModes"] = this.sortCatalogs(response.data.modoTransporte, "text");
        selectCatalog["FreightTerms"] = this.sortCatalogs(response.data.tramoContratado, "text");
        this.setState(
          {
            selectCatalog,
          }
        );
      })
      .catch((error) => {
        console.warn(error);
      });
  };

  sleep = (milliseconds) => {
    return new Promise((resolve) => setTimeout(resolve, milliseconds));
  };

  handleChangeDate = (name, isEdit) => (date, dateString) => {
    let { info, errorPass, confirmPassError, guardarDisabled } = this.state;

    info[name] = date;


    this.setState(
      { info, errorPass, confirmPassError, guardarDisabled },
      () => {
        this.renderForm(isEdit);
        this.validarCampos();
      }
    );
  };
  handleChange = (name, isEdit, type) => (event) => {
    let { info, errorPass, confirmPassError, guardarDisabled, fieldsDependency } = this.state;
    if (type == "numeric") {
      const re = /^(\d+(\.\d{0,4})?|\.?\d{1,2})$/;

      if (event.target.value === '' || re.test(event.target.value)) {
        info[name] = event.target.value;

        if (info['GrossWeight'] && info['QTYOrdered']) info['TotalWeight'] = info['GrossWeight'] * info['QTYOrdered']
        else info['TotalWeight'] = ""

      }
    } else {
      info[name] = event.target.value;
    }

    fieldsDependency.forEach((fieldArray) => {
      if (fieldArray.indexOf(name) >= 0) {
        let flagRequired = false;
        fieldArray.forEach((field) => {
          if (!flagRequired) {
            flagRequired = info[field] && info[field] != "";
          }
        })


        this.state.TemplateForms.map((TemplateForm) => {
          TemplateForm[isEdit ? "edit" : "create"].map((field) => {
            if (fieldArray.indexOf(field.id) >= 0) {
              field.required = flagRequired;
            }
          })
        })
      }
    })

    this.setState(
      { info, errorPass, confirmPassError, guardarDisabled },
      () => {
        this.renderForm(isEdit)
        this.validateSaveOrder()
      }
    );
  };

  validarCampos = (isEdit) => {
    let { info } = this.state;
    var valido = true;
    this.state.TemplateForms.map((TemplateForm) => {
      var campos = TemplateForm[isEdit ? "edit" : "create"];

      campos.map((campo) => {
        if (campo.required) {
          if (!info[campo.id] || info[campo.id] === "") {
            valido = false;
          }
        }
      });

    })


    return valido;
  };

  // handleChangeSelect = (selected) => (event) => {
  //   /**
  //     1-Admin
  //     2-Euro SU
  //   */
  //   let { showClientes, flatNext, newSelected } = this.state;
  //   console.log("showClientes");
  //   showClientes = true;

  //   if (selected === "RolId") {
  //     if (event && [1, 2].indexOf(event.value) >= 0) {
  //       showClientes = false;
  //     } else if (newSelected.length <= 0 && flatNext) {
  //       flatNext = false;
  //     }

  //   }
  //   document.getElementById(selected).style.color = 'black';
  //   if (event && event.value) {
  //     let { user } = this.state;
  //     user[selected] = event.value;
  //     this.setState({ selected, showClientes, flatNext }, () => {
  //       this.buildFormCreate();
  //     });
  //   } else {
  //     let { user } = this.state;
  //     user[selected] = '';
  //     this.setState({ selected, showClientes, flatNext }, () => {
  //       this.buildFormCreate();
  //     });
  //   }
  // };

  recieve = (array) => {
    this.setState({
      newSelected: array,
    });
  };

  dataReport = (data, edit) => {
    let dataReport = { data: data, userId: this.props._user };

    this.setState({
      dataReport,
    });
  };

  recieveProps = (object, open) => {

    let { info, deliverAddressInput, pickupAddressInput, isEditing } = this.state;
    info[object.stateField] = object.id;
    if (!deliverAddressInput && object.stateField == "DeliveryAddress") {
      info["SpecialInstructions"] = object.id
    }
    if (!pickupAddressInput && object.stateField == "PickupAddress") {
      info["PickupGoods"] = object.id
    }

    this.setState({
      info
    }, () => { this.renderForm(isEditing); this.validateSaveOrder() })
  }


  validateSaveOrder = (evt) => {
    let { TemplateForms, infoValid, info } = this.state;

    let validation = [];
    let errors = [];
    TemplateForms.map((TemplateForm) => {
      let Forms = TemplateForm.edit;

      Forms.map((e) => {
        if (e.required) {
          validation.push(e);
        }
        return e;
      });

    });
    validation.forEach((e) => {
      if (!info[e.id] || info[e.id] === "") {
        errors.push(e.id);

      }
    });


    //Validacion de campos en componente de proveedores y consignatarios
    if (!info["DeliveryAddress"] == !info["DeliveryAddress"] === "") {
      errors.push("DeliveryAddress");
    }
    if (!info["ConsigneeId"] == !info["ConsigneeId"] === "") {
      errors.push("ConsigneeId");
    }
    if (!info["SupplierId"] == !info["SupplierId"] === "") {
      errors.push("SupplierId");
    }
    if (!info["PickupAddress"] == !info["PickupAddress"] === "") {
      errors.push("PickupAddress");
    }
    infoValid = !(errors.length > 0);
    this.setState({ infoValid })
  };





  limpiarDatos = (info) => {
    let tmpInfo = _.cloneDeep(info);

    if (tmpInfo.data.ActualCargoReadyDate) {
      if (typeof tmpInfo.data.ActualCargoReadyDate === 'string') {
        tmpInfo.data.ActualCargoReadyDate = moment(tmpInfo.data.ActualCargoReadyDate, "DD-MM-YYYY").format('YYYY-MM-DD')
      } else {
        tmpInfo.data.ActualCargoReadyDate = moment(tmpInfo.data.ActualCargoReadyDate).format('YYYY-MM-DD');
      }
    } else {
      delete tmpInfo.data.ActualCargoReadyDate;
    }
    if (tmpInfo.data.ActualPickupDate) {
      if (typeof tmpInfo.data.ActualPickupDate === 'string') {
        tmpInfo.data.ActualPickupDate = moment(tmpInfo.data.ActualPickupDate, "DD-MM-YYYY").format('YYYY-MM-DD')
      } else {
        tmpInfo.data.ActualPickupDate = moment(tmpInfo.data.ActualPickupDate).format('YYYY-MM-DD');
      }
    } else {
      delete tmpInfo.data.ActualPickupDate;
    }
    if (tmpInfo.data.EstPickupDate) {
      if (typeof tmpInfo.data.EstPickupDate === 'string') {
        tmpInfo.data.EstPickupDate = moment(tmpInfo.data.EstPickupDate, "DD-MM-YYYY").format('YYYY-MM-DD')
      } else {
        tmpInfo.data.EstPickupDate = moment(tmpInfo.data.EstPickupDate).format('YYYY-MM-DD');
      }
    } else {
      delete tmpInfo.data.EstPickupDate;
    }
    if (tmpInfo.data.FinalDestinationArrivalDate) {
      if (typeof tmpInfo.data.FinalDestinationArrivalDate === 'string') {
        tmpInfo.data.FinalDestinationArrivalDate = moment(tmpInfo.data.FinalDestinationArrivalDate, "DD-MM-YYYY").format('YYYY-MM-DD')
      } else {
        tmpInfo.data.FinalDestinationArrivalDate = moment(tmpInfo.data.FinalDestinationArrivalDate).format('YYYY-MM-DD');
      }
    } else {
      delete tmpInfo.data.FinalDestinationArrivalDate;
    }


    if (tmpInfo.data.EstCargoReadyDate) {
      if (typeof tmpInfo.data.EstCargoReadyDate === 'string') {
        tmpInfo.data.EstCargoReadyDate = moment(tmpInfo.data.EstCargoReadyDate, "DD-MM-YYYY").format('YYYY-MM-DD')
      } else {
        tmpInfo.data.EstCargoReadyDate = moment(tmpInfo.data.EstCargoReadyDate).format('YYYY-MM-DD');
      }
    } else {
      delete tmpInfo.data.EstCargoReadyDate;
    }

    if (tmpInfo.data.PromiseCargoReadyDate) {
      if (typeof tmpInfo.data.PromiseCargoReadyDate === 'string') {
        tmpInfo.data.PromiseCargoReadyDate = moment(tmpInfo.data.PromiseCargoReadyDate, "DD-MM-YYYY").format('YYYY-MM-DD')
      } else {
        tmpInfo.data.PromiseCargoReadyDate = moment(tmpInfo.data.PromiseCargoReadyDate).format('YYYY-MM-DD');
      }
    } else {
      delete tmpInfo.data.PromiseCargoReadyDate;
    }
    if (tmpInfo.data.RequiredDateDestination) {
      if (typeof tmpInfo.data.RequiredDateDestination === 'string') {
        tmpInfo.data.RequiredDateDestination = moment(tmpInfo.data.RequiredDateDestination, "DD-MM-YYYY").format('YYYY-MM-DD')
      } else {
        tmpInfo.data.RequiredDateDestination = moment(tmpInfo.data.RequiredDateDestination).format('YYYY-MM-DD');
      }
    } else {
      delete tmpInfo.data.RequiredDateDestination;
    }
    if (tmpInfo.data.TransitToFinalDestinationDate) {
      if (typeof tmpInfo.data.TransitToFinalDestinationDate === 'string') {
        tmpInfo.data.TransitToFinalDestinationDate = moment(tmpInfo.data.TransitToFinalDestinationDate, "DD-MM-YYYY").format('YYYY-MM-DD')
      } else {
        tmpInfo.data.TransitToFinalDestinationDate = moment(tmpInfo.data.TransitToFinalDestinationDate).format('YYYY-MM-DD');
      }

    } else {
      delete tmpInfo.data.TransitToFinalDestinationDate;
    }


    if (!tmpInfo.data.Length || tmpInfo.data.Length == "") {
      delete tmpInfo.data.Length;
    }
    if (!tmpInfo.data.Width || tmpInfo.data.Width == "") {
      delete tmpInfo.data.Width;
    }
    if (!tmpInfo.data.Height || tmpInfo.data.Height == "") {
      delete tmpInfo.data.Height;
    }
    if (!tmpInfo.data.UOMDimensions || tmpInfo.data.UOMDimensions == "") {
      delete tmpInfo.data.UOMDimensions;
    }


    if (!tmpInfo.data.GrossWeight || tmpInfo.data.GrossWeight == "") {
      delete tmpInfo.data.GrossWeight;
    }
    if (!tmpInfo.data.UOMWeight || tmpInfo.data.UOMWeight == "") {
      delete tmpInfo.data.UOMWeight;
    }

    if (!tmpInfo.data.UpdateDate || tmpInfo.data.UpdateDate == "") {
      delete tmpInfo.data.UpdateDate;
    }
    if (!tmpInfo.data.SupplierContactId || tmpInfo.data.SupplierContactId == "") {
      delete tmpInfo.data.SupplierContactId;
    }
    if (!tmpInfo.data.ConsigneeContacId || tmpInfo.data.ConsigneeContacId == "") {
      delete tmpInfo.data.ConsigneeContacId;
    }
    //No se usa
    // delete tmpInfo.data.ActualPickupDate;
    delete tmpInfo.data.ActualCollectionDate;
    //Innecesarios
    delete tmpInfo.data.UpdateDate;
    delete tmpInfo.data.ConsigneeState;
    delete tmpInfo.data.SOCreationDate;
    delete tmpInfo.data.userCreate;
    delete tmpInfo.data.userUpdate;
    delete tmpInfo.data.DeletedDate;
    delete tmpInfo.data.OrderRelationshipId;
    delete tmpInfo.data.Deleted;
    delete tmpInfo.data.Status;
    delete tmpInfo.data.StatusId;
    delete tmpInfo.data.SupplierState;
    delete tmpInfo.data.TransportPlanId;
    delete tmpInfo.data.UserCreateId;
    delete tmpInfo.data.UserCreateName;
    delete tmpInfo.data.UserUpdateId;
    delete tmpInfo.data.UserUpdateName;
    delete tmpInfo.data.CustomerState;
    delete tmpInfo.data.CustomerName;
    delete tmpInfo.data.CustomerAddress;
    delete tmpInfo.data.CustomerTelephone;
    delete tmpInfo.data.CustomerCity;
    delete tmpInfo.data.SupplierTelephone;
    delete tmpInfo.data.CustomerCatCountryId;
    delete tmpInfo.data.CustomerCountry;
    delete tmpInfo.data.TransportMode;
    delete tmpInfo.data.Incoterm;
    delete tmpInfo.data.FreightTerm;
    delete tmpInfo.data.UOMWeightDescription
    delete tmpInfo.data.UOMOrderedDescription
    delete tmpInfo.data.SupplierCode;
    delete tmpInfo.data.SupplierName;
    delete tmpInfo.data.SupplierCity;
    delete tmpInfo.data.SupplierAddress;
    delete tmpInfo.data.SupplierContact;
    delete tmpInfo.data.SupplierTelephone;
    delete tmpInfo.data.SupplierCatCountryId;
    delete tmpInfo.data.ConsigneeCatCountryId;
    delete tmpInfo.data.SupplierCountry;
    delete tmpInfo.data.ConsigneeCountry;
    delete tmpInfo.data.ConsigneeCity;
    delete tmpInfo.data.ConsigneeCode;
    delete tmpInfo.data.ConsigneeContact;
    delete tmpInfo.data.ConsigneeAddress;
    delete tmpInfo.data.ConsigneeName;
    delete tmpInfo.data.ConsigneeTelephone;
    delete tmpInfo.data.CheckpPickupAddress;
    delete tmpInfo.data.PickupdAddress;
    delete tmpInfo.data.Cancelled;
    delete tmpInfo.data.UOMDimensionsDescription;
    delete tmpInfo.data.SupplierCodeEPContact;
    delete tmpInfo.data.ConsigneeCodeEPContact;
    delete tmpInfo.data.ShipmentId;


    return _.cloneDeep(tmpInfo);
  }
  updateOrder = async () => {
    let { info, TemplateForms } = this.state;

    let validation = [];
    let errors = "";
    TemplateForms.map((TemplateForm) => {
      TemplateForm["edit"].map((e) => {

        if (e.required === true) {
          validation.push(e);
        }
        return e;
      });

    })
    validation.forEach((e) => {
      if (!info[e.id] || info[e.id] === "") {
        errors += this.props.t(e.label) + ", ";
        document.getElementById(e.id).style.color = "red";
      } else {
        document.getElementById(e.id).style.color = "#000a2e";

      }

    })

    if (errors.length > 0) {
      openNotification('error', this.props.t("please_type_info_required"));
    } else {
      if (!info["DeliveryAddress"] || info["DeliveryAddress"] === "") {
        openNotification('error', this.props.t("Favor de capturar la dirección de entrega"));
      } else if (!info["ConsigneeId"] || info["ConsigneeId"] === "") {
        openNotification('error', this.props.t("Favor de seleccionar un consignatario"));
      } else if (!info["SupplierId"] || info["SupplierId"] === "") {
        openNotification('error', this.props.t("Favor de seleccionar un proveedor"));
      } else if (!info["PickupAddress"] || info["PickupAddress"] === "") {
        openNotification('error', this.props.t("Favor de capturar la dirección de recolección"));
      } else {
        this.setState({ loadingTmpInfo: true }, () => { this.putOrder() });
      }
    }
  };
  putOrder = async () => {
    let { info, selectCatalog } = this.state;

    let data = { data: _.cloneDeep(info) };
    data = this.limpiarDatos(data);
    data.data.UserId = this.props.userid;
    //Debe de estar presente aunque nos e haya agregado
    data.data.CheckPickupAddress = !data.data.CheckPickupAddress || data.data.CheckPickupAddress == 0 ? false : true;
    //Debe de estar presente aunque nos e haya agregado
    data.data.CheckDeliveryAddress = !data.data.CheckDeliveryAddress || data.data.CheckDeliveryAddress == 0 ? false : true;


    let consignee = selectCatalog["consignees"].find((cons) => {
      return cons.entityCode == data.data.ConsigneeId;
    })

    data.data.ConsigneeAPIInfo = consignee;
    data.data.ConsigneeAPIContactInfo = data.data.ConsigneeContacId && data.data.ConsigneeContacId != "" && consignee.contacts != ""
      ? consignee.contacts.find((cont) => { return cont.contactCode == data.data.ConsigneeContacId }) : {};

    let supplier = selectCatalog["suppliers"].find((cons) => {
      return cons.entityCode == data.data.SupplierId;
    })
    data.data.SupplierAPIInfo = supplier;
    data.data.SupplierAPIContactInfo = data.data.SupplierContactId && data.data.SupplierContactId != "" && supplier.contacts != ""
      ? supplier.contacts.find((cont) => { return cont.contactCode == data.data.SupplierContactId }) : {};

    await axios
      .put(`${Services.ORDEN_SERV.path}orden/updateOrder`, data)
      .then((response) => {
        this.sendMessage(this.props.t("order_successfully_updated"), "success");
        this.sleep(1000).then(() => {
          this.setState({ loadingTmpInfo: false }, () => { this.props.actualiza() });
        });
      })
      .catch((error) => {
        this.setState({ loadingTmpInfo: false }, this.sendMessage(error.response.data.message, "error"));
      });
  };


  /*
    ####################################GENERACION DE CAMPOS####################################
   */

  generarInfoEmbarque = () => {
    let { infoEmbarque, TemplateEmbarque, embarqueInfo } = this.state;

    if (infoEmbarque && !_.isEmpty(infoEmbarque)) {
      embarqueInfo.push(
        TemplateEmbarque["embarque"].map((e) => {
          var attrInfo = "";
          var extraClass = "";

          if (e.type === "Label") {
            attrInfo = <span>{infoEmbarque[e.id] && infoEmbarque[e.id] != "" ? infoEmbarque[e.id] : "-"}</span>;
          } else if (e.type === "LabelNumber") {
            attrInfo = <span>{infoEmbarque[e.id] && infoEmbarque[e.id] != "" ? Number(infoEmbarque[e.id]).toLocaleString("En-us") : "-"}</span>;
          } else if (e.type === "LabelLink") {
            attrInfo = <Link className='link-euro' to={'/shipments-details/' + infoEmbarque.ShipmentId}>{infoEmbarque.ShipmentNumber}</Link>
            // attrInfo = <Link className='link-euro' to="#">{infoEmbarque.ShipmentNumber}</Link>
          } else if (e.type === "list") {
            // attrInfo = <ul>
            //     {info[e.id].map(element => {
            //         return <li>{element}</li>
            //     })}
            // </ul>
            attrInfo = <span>{infoEmbarque[e.id].length}</span>;
            extraClass = "";
          }

          return (
            <div className={e.class} style={{ paddingTop: "1%" }}>
              {
                <div className="row">
                  <div className={"col-md-12 col-lg-12 col-sm-6 " + extraClass}>
                    <span style={{ fontWeight: "bold" }}>{this.props.t(e.label)}</span>
                  </div>
                  <div className={"col-md-12 col-lg-12 col-sm-6 " + extraClass}>
                    {attrInfo}
                  </div>
                </div>
              }
            </div>
          );
        })
      )
      if (infoEmbarque.Containers.length > 0) {


        embarqueInfo.push(

          <div style={{ paddingTop: "1%" }}>
            {
              <div className="row">
                <Table
                  columns={this.state.containerColumns}
                  data={infoEmbarque.Containers}
                  options={{
                    large: false,
                    downloads: {
                      pdf: false,
                      xlsx: false
                    }
                  }} />
              </div>
            }
          </div>
        );

      }
    }

    this.setState({
      embarqueInfo,
      loadingInfo: false
    });
  };
  generarInfoGeneral = () => {
    let { info, isEdit, showClientes, generalInfo, selectCatalog, TemplateForms } = this.state;
    generalInfo = [];
    TemplateForms.map((TemplateForm) => {
      generalInfo.push({
        id: TemplateForm.id, expanded: true, titulo: TemplateForm.titulo, logo: TemplateForm.logo, form: TemplateForm["previewForm"].map((e) => {
          var attrInfo = "";
          var extraClass = "";

          if (e.type == "CustomEntidades") {
            attrInfo = (
              <div className="row" style={{ width: "100%" }}>
                <div className="col-md-6">
                  <Proveedor
                    isEdit={isEdit}
                    key="proveedor"
                    CustomerId={info.CustomerId}
                    suppliers={
                      selectCatalog["suppliers"]
                        ? selectCatalog["suppliers"]
                        : []
                    }
                    sendProps={this.recieveProps}
                    info={info}
                    errors={this.state.errors}
                  ></Proveedor>
                </div>
                <div className="col-md-6">
                  <Consignatario
                    key="consignatario"
                    CustomerId={info.CustomerId}
                    consignees={
                      selectCatalog["consignees"]
                        ? selectCatalog["consignees"]
                        : []
                    }
                    isEdit={isEdit}
                    sendProps={this.recieveProps}
                    info={info}
                    errors={this.state.errors}
                  ></Consignatario>
                </div>
              </div>
            );
          } else if (e.type === "Label") {
            attrInfo = <span className="label-euro">{info[e.id]}</span>;
          } else if (e.type === "LabelNumber") {
            attrInfo = <span>{formatMeasurement(info[e.id], e.format)}</span>;
          } else if (e.type === "list") {
            // attrInfo = <ul>
            //     {info[e.id].map(element => {
            //         return <li>{element}</li>
            //     })}
            // </ul>
            attrInfo = <span className="label-euro">{info[e.id].length}</span>;
            extraClass = "";
          } else if (e.type === "select") {
            if (info[e.id]) {
              let catalog = this.state.selectCatalog[e.selectCatalogName];

              var value = catalog.filter((cat) => cat.key === info[e.id]);

              attrInfo = <span className="label-euro">{value[0].text}</span>;
            }
          } else if (e.type === "password") {
            if (this.state.isEdit) {
              return;
            }
            attrInfo = <span className="label-euro">***********</span>;
          }
          return (
            <div className={e.class} style={{ paddingTop: "1%" }}>
              {
                <div className="row">
                  <div className={"col-md-12 col-lg-12 col-sm-6 " + extraClass}>
                    <span className="label-euro" style={{ fontWeight: "bold" }}>{this.props.t(e.label)}</span>
                  </div>
                  <div className={"col-md-12 col-lg-12 col-sm-6 " + extraClass}>
                    {attrInfo}
                  </div>
                </div>
              }
            </div>
          );
        })
      })
    });

    if (!isEdit) {
      showClientes = true;
    }
    var guardarDisabled = true;
    if ([1, 2].indexOf(info["RoleId"]) >= 0) {
      guardarDisabled = false;
      showClientes = false;
    } else if (info.Entities && info.Entities.length > 0) {
      guardarDisabled = false;
    }
    this.setState({
      camposUsuario: false,
      showClientes,
      guardarDisabled,
      generalInfo,
    });
  };

  setDateOpen = (flag, id) => {
    let { dateOpen } = this.state;
    dateOpen[id] = flag
    this.setState({ dateOpen }, () => { this.renderForm(true) })
  }
  sortCatalogs = (array, attr) => {
    array.sort((a, b) => a[attr].localeCompare(b[attr]))
    return array;
  }
  renderForm = (isEdit) => {
    let {
      TemplateForms,
      info,
      selectCatalog,
      dateOpen,
      showCatalogModal,
      createFormsData,
    } = this.state;
    createFormsData = [];
    const { classes } = this.props;
    TemplateForms.map((TemplateForm) => {
      createFormsData.push({
        id: TemplateForm.id, expanded: true, titulo: TemplateForm.titulo, logo: TemplateForm.logo, form: TemplateForm[isEdit ? "edit" : "create"].map(
          (e) => {
            if (e.type === "Label") {
              return (
                <div style={{ marginTop: "15px" }} className={e.class} key={e.id}>
                  <Fade left opposite>
                    {" "}
                    <span id={e.id} style={e.style}>
                      <label>
                        {this.props.t(e.label)}{" "}
                        {e.required === true ? (
                          <span style={{ color: "#ff0000" }}>*</span>
                        ) : (
                          ""
                        )}
                      </label>
                    </span>
                  </Fade>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <span>{info[e.id] && info[e.id] != "" ? info[e.id] : "-"}</span>
                  </div>
                </div>
              );
            } else if (e.type === "Input") {
              return (
                <div style={{ marginTop: "15px" }} className={e.class} key={e.id}>
                  <Fade left opposite>
                    {" "}
                    <span id={e.id} style={e.style}>
                      <label>
                        {this.props.t(e.label)}{" "}
                        {e.required === true ? (
                          <span style={{ color: "#ff0000" }}>*</span>
                        ) : (
                          ""
                        )}
                      </label>
                    </span>
                  </Fade>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <TextField
                      // label={e.placeHolder} 
                      disabled={e.disabled}
                      variant="standard"
                      type={e.datatype}
                      name={e.id}
                      value={info[e.id]}
                      maxlength={e.maxlength}
                      minlength={e.minlength}
                      InputProps={{
                        classes: {
                          input: 'input-euro',
                        },
                      }}
                      onChange={this.handleChange(e.id, isEdit ? true : false, e.validation)}
                      max={e.max}
                      key={e.id}
                    />
                  </div>

                </div>
              );
            } else if (e.type === "TextArea") {
              return (
                <div style={{ marginTop: "15px" }} className={e.class} key={e.id}>
                  <Fade left opposite>
                    {" "}
                    <span id={e.id} style={e.style}>
                      <label>
                        {this.props.t(e.label)}{" "}
                        {e.required === true ? (
                          <span style={{ color: "#ff0000" }}>*</span>
                        ) : (
                          ""
                        )}
                      </label>
                    </span>
                  </Fade>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <TextArea
                      className="custom-textarea"
                      required={e.required}
                      onFocus={(e) => {
                        e.target.setAttribute("autocomplete", "none");
                      }}
                      type={e.datatype}
                      placeholder={this.props.t(e.placeHolder)}
                      name={e.id}
                      key={e.id}
                      value={info[e.id]}
                      onChange={this.handleChange(e.id, isEdit ? true : false)}
                    />
                  </div>
                </div>
              );
            } else if (e.type === "LabelRef") {
              return (
                <div style={{ marginTop: "15px" }} className={e.class} key={e.id}>
                  <Fade left opposite>
                    {" "}
                    <span id={e.id} style={e.style}>
                      <label>
                        {this.props.t(e.label)}{" "}
                        {e.required === true ? (
                          <span style={{ color: "#ff0000" }}>*</span>
                        ) : (
                          ""
                        )}
                      </label>
                    </span>
                  </Fade>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <Label>{info[e.id]}</Label>
                  </div>
                </div>
              );
            } else if (e.type === "CustomEntidades") {
              return (<div className="row" style={{ width: '100%', marginLeft: "5px" }}>
                <div className="col-md-6">
                  <Proveedor isEdit={e.edit == 0 ? false : isEdit} sendProps={this.recieveProps} info={info}
                    CustomerId={info.CustomerId} suppliers={selectCatalog["suppliers"] ? selectCatalog["suppliers"] : []}
                    selected={info["Proveedor"]} errors={this.state.errors} ></Proveedor>
                </div>
                <div className="col-md-6">
                  <Consignatario isEdit={e.edit == 0 ? false : isEdit} sendProps={this.recieveProps} info={info}
                    CustomerId={info.CustomerId} consignees={selectCatalog["consignees"] ? selectCatalog["consignees"] : []}
                    selected={info["Consignatario"]} errors={this.state.errors} ></Consignatario>
                </div>

              </div>)
            } else if (e.type === "Select") {
              let autocompleteValue = this.findInCatalog(info, e.id, e.selectCatalogName);
              return (
                <div style={{ marginTop: "15px" }} className={e.class} key={e.id}>
                  <Fade left opposite>
                    <span id={e.id} style={e.style}>
                      {" "}
                      <label>
                        {this.props.t(e.label)}{" "}
                        {e.required ? (
                          <span style={{ color: "#ff0000" }}>*</span>
                        ) : (
                          ""
                        )}{" "}
                      </label>
                    </span>
                  </Fade>

                  <Autocomplete
                    disabled={e.disabled}
                    closeText={false}
                    openText={false}
                    className='input-euro'
                    id={e.id}
                    style={{ marginTop: "3px" }}
                    size="small"
                    // freeSolo
                    ListboxProps={{
                      sx: { fontSize: 12 },
                    }}
                    sx={{
                      '& .MuiAutocomplete-input, & .MuiInputLabel-root': {
                        fontSize: 12,
                      },
                    }}
                    options={selectCatalog[e.selectCatalogName] ? selectCatalog[e.selectCatalogName] : []}
                    getOptionLabel={(option) => (option.text)}
                    renderOption={(props, option, value) => {
                      props.key = option.key;
                      return <div  {...props}>
                        {
                          option.subText && option.subText != "" ?
                            <div className="row">
                              <div className="col-12">{option.text}</div>


                              <div className="col-12">
                                <label style={{ opacity: ".5" }}>{option.subText}</label> </div>


                            </div>
                            :
                            <span>{option.text}</span>
                        }
                      </div>
                    }
                    }
                    filterOptions={(options, event) => {
                      let filteredOptions = options.filter((opt) => {
                        return event.inputValue == "" ||
                          opt.text.toLowerCase().includes(event.inputValue.toLowerCase())
                      })
                      return filteredOptions;
                    }}
                    onChange={this.handleChangeDrop(e.id, isEdit)}
                    value={autocompleteValue}
                    classes={e.id == "CustomerId" ? {
                      clearIndicatorDirty: classes.clearIndicator,
                      popupIndicator: classes.popupIndicator,
                      popupIndicatorOpen: classes.popupIndicatorOpen,
                    } : false}
                    renderInput={(params) => {
                      params.inputProps.value = autocompleteValue && autocompleteValue.text ? autocompleteValue.text : params.inputProps.value;
                      return <TextField
                        {...params
                        }
                        variant="standard"
                        className={classes.textfield}

                      />

                    }}
                  />
                  <Fade left opposite>
                    <label style={e.style}>{e.error}</label>
                  </Fade>
                </div>
              );
            } else if (e.type === "Date") {
              let dateId = e.id;
              return (
                <div style={{ marginTop: "15px" }} className={e.class} key={e.id}>
                  <Fade left opposite>
                    <span id={e.id} style={e.style}>
                      {" "}
                      <label>
                        {this.props.t(e.label)}{" "}
                        {e.required ? (
                          <span style={{ color: "#ff0000" }}>*</span>
                        ) : (
                          ""
                        )}{" "}
                      </label>
                    </span>
                  </Fade>
                  <LocalizationProvider
                    adapterLocale={this.props.lng == "US" ? enLocale : esLocale}
                    dateAdapter={AdapterDateFns}>
                    <DatePicker
                      className="search-drops"
                      placeholder={this.props.t(e.label)}
                      OpenPickerButtonProps={{ style: { display: 'none' } }}
                      open={dateOpen[dateId] == true}
                      onOpen={() => this.setDateOpen(true, dateId)}
                      onClose={() => this.setDateOpen(false, dateId)}
                      id={e.id}
                      options={selectCatalog[e.selectCatalogName]}
                      inputFormat={e.format}
                      renderInput={
                        (params) =>
                          <TextField
                            className={classes.datefield}
                            onClick={(e) => this.setDateOpen(true, dateId)}
                            variant="standard" {...params} />
                      }
                      value={info[e.id] ? moment(info[e.id], 'DD-MM-YYYY') : null}
                      onChange={this.handleChangeDate(e.id, isEdit)}
                    />
                  </LocalizationProvider>
                  {/* value={info[e.id] ? moment(info[e.id], 'DD-MM-YYYY') : ""} */}

                  <Fade left opposite>
                    <label style={e.style}>{e.error}</label>
                  </Fade>
                </div>
              );
            } else {
              return (
                <div
                  className={e.class}
                  style={{ marginTop: "20px" }}
                  key={e.id}
                ></div>
              );
            }
          }
        )
      })
    });
    this.setState({
      createFormsData,
      showCatalogModal,
      info,
      isEdit,
      loadingInfo: false
    });
  };

  findInCatalog = (info, id, catalogName) => {
    let { selectCatalog } = this.state;
    let value = {};
    value = selectCatalog[catalogName] ? selectCatalog[catalogName].find((catalog) => { return info[id] == catalog.value }) : {};
    return value;
  }


  validateSaveUser = (e) => (evt) => {
    let { TemplateForms } = this.state;

    let validation = [];
    let errors = "";
    TemplateForms.map((TemplateForm) => {
      let Forms = TemplateForm.createUser;
      Forms.map((e) => {
        if (e.required === true) {
          validation.push(e);
        }
        return e;
      });
      validation.forEach((e) => {
        if (this.state.info[e.id] === "") {
          errors += this.props.t(e.label) + ", ";
          document.getElementById(e.id).style.color = "red";
        } else {
          document.getElementById(e.id).style.color = "black";
        }
      });
    })


    if (errors.length > 0) {
      openNotification('error', "Required fields: " + errors + "");
    } else {
      this.generarInfoGeneral();
    }
  };
  panelChange = (id) => (evt, expanded) => {
    let { createFormsData, generalInfo } = this.state;
    createFormsData.map((form) => {
      if (form.id == id) {
        form.expanded = expanded;
      }
    })
    generalInfo.map((form) => {
      if (form.id == id) {
        form.expanded = expanded;
      }
    })

    this.setState({ createFormsData });
  };
  panelEmbarqueChange = (evt, expanded) => {
    this.setState({ panelEmbarque: expanded });
  };

  render() {
    let { loadingInfo, loadingTmpInfo, info, isMobil } = this.state;

    return loadingInfo ? (
      <Loader />
    ) : (<ContainerWrapper>
      {loadingTmpInfo ? <Loader /> : false}

      {this.state.isEditing ?
        <>
          <Row>
            <Col xs={12} md={12} lg={12} style={{ marginTop: isMobil ? '' : "-70px" }}>
              <Button
                color="primary"
                className="float-right custom-width-btn ml-2"
                onClick={() => this.updateOrder()}
              >
                {this.props.t("update")}
              </Button>
              <Button
                color="secondary"
                className="float-right custom-width-btn"
                onClick={() => this.props.cancelar()}
              >
                {this.props.t("cancel")}
              </Button>
            </Col>
          </Row>
        </>
        : stubFalse
      }
      {
        this.state.isEditing ? this.state.createFormsData ? this.state.createFormsData.map((form) => {
          return <Card className="myCard">

            <ExpansionPanel elevation={0} defaultExpanded onChange={this.panelChange(form.id)}>
              <ExpansionPanelSummary onclic expandIcon={form.expanded ? <ExpandLess /> : <ExpandMore />}>
                <div style={{ display: "inline-flex", alignItems: "center" }}>
                  <div style={{ marginRight: "27px" }}></div>
                  < h4 className="euro-title-form" > {this.props.t(form.titulo)}</h4></div>
              </ExpansionPanelSummary>
              <ExpansionPanelDetails>
                <CardBody>

                  <div className="col-12" style={{ marginTop: "-2em", marginLeft: "-3px" }}>
                    {
                      <div>
                        {/* <h4>{form.titulo}</h4> */}

                        <div className="row">
                          {/* <div className="col-12"> */}
                          {form.form}

                          {/* </div> */}
                        </div>
                      </div>
                    }

                  </div>



                </CardBody>
              </ExpansionPanelDetails>
            </ExpansionPanel>

          </Card>
        })
          : false :
          <div>
            <Card className="myCard">
              <CardBody>

                {/* validacion para la visa movil */}
                {
                  !this.state.isMobil ?
                    <div className="row" >
                      <div style={{ display: "inline-flex", alignItems: "center", paddingLeft: "5%" }} className="col-xs-6 col-sm-3 col-lg-3 col-md-3">

                        {
                          (info && info.RefCustomer) ?
                            <span className="custom-number-header">{info.RefCustomer}</span>
                            :
                            false
                        }
                      </div>
                      <div className="col-xs-6 col-sm-3 col-lg-3">
                        <span class="badge badge-euro">{info.Status}</span>
                      </div>
                      {/* // !if -- data.ParentPOId ?  */}
                      <div className="col-xs-12 col-sm-6 col-lg-6 d-flex align-items-center justify-content-end">
                        <div className="mr-2">
                          <span className="date_header_label">{this.props.t("conclude_update")}:  </span>
                          <span>{info.UpdateDate ? info.UpdateDate : ''}</span>
                        </div>
                        <div>
                          <span className="date_header_label"><em > {this.props.t("user")}:  </em></span>
                          <span>{info.userUpdate ? info.userUpdate : ''}</span>
                        </div>
                        <Tooltip
                          style={{ marginLeft: "5px" }}
                          title={
                            <div className="">
                              <div className='col-12 d-flex align-items-center'>
                                <span className="date_header label-euro"><em> {this.props.t("creation_date")}:  </em></span>
                                <b className="label-euro" style={{ marginLeft: "5px" }}>{info.SOCreationDate ? info.SOCreationDate : ''}</b>
                              </div>
                              <div className='col-12'>
                                <span className="date_header label-euro"><em>{this.props.t("user")}: </em></span>
                                <b className="label-euro" style={{ marginLeft: "5px" }}>{info.userCreate ? info.userCreate : ''}</b>
                              </div>
                            </div>}
                          placement="right"
                        >
                          <span className="icon-informative-tooltip custom-icon-tooltip yellow" />
                        </Tooltip>
                      </div>
                    </div >
                    :
                    <div className="col-xs-12 row">
                      {/* <div className="col-xs-12 row" > */}
                      <div style={{ display: "inline-flex", alignItems: "center" }} className="col-xs-6 ">
                        {
                          (info && info.RefCustomer) ?
                            <h4 className="label-euro" onClick={""} >{info.RefCustomer}</h4>
                            // <em onClick={() => {this.props.history.push(`/po-detail-view/${data.ParentPOId}`); resetInfo(data.ParentPOId);}} className='redirect-ponumber'>{this.state.data.PONumber}</em>
                            :
                            false
                        }
                      </div>
                      <div className="col-xs-6" style={{ display: "inline-flex", alignItems: "center" }}>
                        <span class="badge badge-euro">{info.Status}</span>
                      </div>
                      {/* </div> */}
                      {/* <div className="col-xs-12 row" style={{ display: "inline-flex", alignItems: "center" }}  > */}
                      <div className="col-xs-6" style={{ display: "inline-flex", alignItems: "center" }}>
                        <h5 className="date_header label-euro"><em className="label_title"> {this.props.t("conclude_update")}:  </em></h5>
                      </div>
                      <div className="col-xs-6" style={{ display: "inline-flex", alignItems: "center" }}>
                        <b className="label-euro" >{info.UpdateDate ? info.UpdateDate : ''}</b>
                      </div>
                      {/* </div> */}
                      {/* <div className="col-xs-12 row" style={{ display: "inline-flex", alignItems: "center" }}  > */}
                      <div className="col-xs-6" style={{ display: "inline-flex", alignItems: "center" }}>
                        <h5 className="date_header label-euro"><em className="label_title"> {this.props.t("user")}:  </em></h5>
                      </div>
                      <div className="col-xs-6" style={{ display: "inline-flex", alignItems: "center" }}>
                        <b className="label-euro">{info.userUpdate ? info.userUpdate : ''}</b>
                      </div>
                      {/* </div> */}
                      {/* // !if -- data.ParentPOId ?  */}
                      {/* <div className="col-xs-12 col-sm-6 col-lg-6 divEnd " style={{ alignItems: "center" }}>
                      <div style={{ display: "inline-flex", alignItems: "center", marginLeft: "1em" }} className=''>
                        <h5 className="date_header label-euro"><em className="label_title"> Fecha actualización:  </em></h5>
                        <b className="label-euro" style={{ marginLeft: "5px" }}>{info.UpdateDate ? info.UpdateDate : ''}</b>
                      </div>
                      <div style={{ display: "inline-flex", alignItems: "center", marginLeft: "1em" }} className=''>
                        <h5 className="date_header label-euro"><em className="label_title"> Usuario:  </em></h5>
                        <b className="label-euro" style={{ marginLeft: "5px" }}>{info.userUpdate ? info.userUpdate : ''}</b>
                      </div>
                      <Tooltip
                        style={{ marginLeft: "5px" }}
                        title={
                          <div>
                            <div style={{ display: "inline-flex", alignItems: "center", marginLeft: "1em", paddingLeft: "0px" }} className='col-12'>
                              <h5 className="date_header label-euro"><em className="label_title"> Fecha creación:  </em></h5>
                              <b className="label-euro" style={{ marginLeft: "5px" }}>{info.SOCreationDate ? info.SOCreationDate : ''}</b>
                            </div>
                            <div style={{ display: "inline-flex", alignItems: "center", marginLeft: "1em", paddingLeft: "0px" }} className='col-12'>
                              <h5 className="date_header label-euro"><em className="label_title"> Usuario:  </em></h5>
                              <b className="label-euro" style={{ marginLeft: "5px" }}>{info.userCreate ? info.userCreate : ''}</b>
                            </div>
                          </div>}

                        placement="right"
                      >
                        <em

                          className="icon-final-25 mr-3 euro-info-icon"
                        ></em>
                      </Tooltip>
                    </div> */}
                    </div>
                }

              </CardBody>
            </Card>
            <Card className="myCard">
              <CardBody>
                <StepperEvent steps={this.state.steps} />
              </CardBody>
            </Card>
            {
              this.state.generalInfo.map((general) => {
                return (
                  <Card className="myCard">
                    <ExpansionPanel elevation={0} defaultExpanded onChange={this.panelChange(general.id)}>
                      <ExpansionPanelSummary onclic expandIcon={general.expanded ? <ExpandLess /> : <ExpandMore />}>
                        <span className="euro-title-form" > {this.props.t(general.titulo)}</span>
                      </ExpansionPanelSummary>
                      <ExpansionPanelDetails>
                        <CardBody>
                          <div className="row">
                            {general.form}
                          </div>
                        </CardBody>
                      </ExpansionPanelDetails>
                    </ExpansionPanel>
                  </Card>)
              })
            }
            {
              this.state.embarqueInfo && this.state.embarqueInfo.length > 0 ?
                <div>
                  <Card className="myCard">
                    <ExpansionPanel elevation={0} defaultExpanded onChange={this.panelEmbarqueChange}>
                      <ExpansionPanelSummary onclic expandIcon={this.state.panelEmbarque ? <ExpandLess /> : <ExpandMore />}>
                        <div style={{ display: "inline-flex", alignItems: "center" }}>
                          {/* <img style={{ margin: '6px', marginTop: '-1px' }} alt=""
                        src="https://magiclog.blob.core.windows.net/europartnerspic/Icono_trazabilidad-de-embarques.svg"
                        height="35" width="35"></img> */}
                          <span className="euro-title-form" >{this.props.t("shipment_info")}</span></div>
                      </ExpansionPanelSummary>
                      <ExpansionPanelDetails>
                        <CardBody>
                          <div className="col-12" style={{ marginTop: "-2em", marginLeft: "-3px" }}>
                            <div>
                              <div className="row">
                                {this.state.embarqueInfo[0]}
                              </div>
                              <div class="ui divider"></div>
                              {
                                this.state.embarqueInfo.length > 1 ?
                                  <div className="row">

                                    {this.state.embarqueInfo[1]}


                                  </div> : false
                              }
                            </div>


                          </div>



                        </CardBody>
                      </ExpansionPanelDetails>
                    </ExpansionPanel>

                  </Card></div>
                : false
            }
          </div >

      }

    </ContainerWrapper >)
  }
}

export default withNamespaces()(withRouter(withStyles(useStyles)(createUsers)));
